module.exports = __webpack_public_path__ + "img/ic-warning-red.svg";